import React from 'react'
import { useTranslation } from 'react-i18next'

import ImageAsset from '@components/image_asset'

import styles from '@components/blocks/three_columns_block.module.scss'

const image1 = {
  fields: {
    description: 'hand holding phone',
    file: {
      url: '/images/sms/info1.svg',
    },
  },
}

const image2 = {
  fields: {
    description: 'phone checklist',
    file: {
      url: '/images/sms/info2.svg',
    },
  },
}

const image3 = {
  fields: {
    description: 'child',
    file: {
      url: '/images/sms/info3.svg',
    },
  },
}

const SmsInfographic = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.threeColumnsBlock}>
      <div className={styles.threeColumnsBlock__col}>
        <ImageAsset
          className={styles.threeColumnsBlock__image}
          asset={image1}
          width="300"
          height="300"
        />
        <div className={styles.threeColumnsBlock__text}>{t('sms.infoText1')}</div>
      </div>
      <div className={styles.threeColumnsBlock__col}>
        <ImageAsset
          className={styles.threeColumnsBlock__image}
          asset={image2}
          width="300"
          height="300"
        />
        <div className={styles.threeColumnsBlock__text}>{t('sms.infoText2')}</div>
      </div>
      <div className={styles.threeColumnsBlock__col}>
        <ImageAsset
          className={styles.threeColumnsBlock__image}
          asset={image3}
          width="300"
          height="300"
        />
        <div className={styles.threeColumnsBlock__text}>{t('sms.infoText3')}</div>
      </div>
    </div>
  )
}

export { SmsInfographic }
